<template>
    <div class="">
        <div class="boxShadow noOverflow bg-white mb-3 p-4">
            <button v-if="this.$checkRole(this.$accessModule.payment_voucher, 'update') && pvItem.status !== 'Posted'" type="button" class="btn btnEditBox btn-secondary" @click="openEditPVdate"><img src="img/iconPencil.png" alt=""></button>
            <b-row class="pr-4">
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex field-display-basic label-min-w-auto">
                            <span class="label">PV Date</span>
                            <span class="value">{{pvItem.pv_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}</span>
                        </div>
                        <div class="d-flex field-display-basic label-min-w-auto">
                            <span class="label">Approval Template</span>
                            <span class="value">{{ showApprovalTitle(pvItem.approval_template) }}</span>
                            <gofix-button class="pt-0 pb-0 ml-2" label="Edit" @click="editApprovalTemplate()" v-if="pvItem.status == 'Draft' && pvItem.approval_template_id" noBorder fontNormal small></gofix-button>
                        </div>
                        <div class="d-flex justify-content-end">
                            <div class="d-flex field-display-basic label-min-w-auto mr-5">
                                <span class="label">Created By</span>
                                <span class="value">{{pvItem.get_created_by ? pvItem.get_created_by.name : "--" }}</span>
                            </div>
                            <div class="d-flex field-display-basic label-min-w-auto">
                                <span class="label">Created on</span>
                                <span class="value">{{ pvItem.created_on | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}</span>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="boxShadow noOverflow bg-white mb-3 p-4">
            <button v-if="this.$checkRole(this.$accessModule.payment_voucher, 'update') && pvItem.status !== 'Posted'" type="button" class="btn btnEditBox btn-secondary" @click="openEditPVInfo"><img src="img/iconPencil.png" alt=""></button>
            <div class="title mb-4">Payment Details</div>
            <b-row class="">
                <b-col md="12" class="mb-4" v-if="pvItem.contract">
                  <div class="d-flex field-display-basic">
                    <span class="label">Contract</span>
                    <span class="value">{{pvItem.contract.contract_name || "--"}}</span>
                  </div>
                </b-col>
                <b-col md="5">
                    <b-row class="mb-4">
                        <b-col md="6">
                            <div class="d-flex field-display-basic">
                                <span class="label">Pay To</span>
                                <span class="value">{{pvItem.pay_to_name || "--"}}</span>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div class="d-flex field-display-basic">
                                <span class="label">Creditor Code</span>
                                <!-- <span class="value">{{(pvItem.creditor_code  ? pvItem.creditor_code : '--')+(pvItem.get_pay_to && pvItem.get_pay_to.get_debtor_code && pvItem.get_pay_to.get_debtor_code.source_description ? (' - ' + pvItem.get_pay_to.get_debtor_code.source_description) : '')}}</span> -->
                                <span class="value">{{ getCreditorCode }}</span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="6">
                            <div class="d-flex field-display-basic">
                                <span class="label">Payment Mode</span>
                                <span class="value">{{pvItem.payment_mode || "--"}}</span>
                            </div>
                        </b-col>
                        <b-col md="6" v-if="pvItem.payment_mode === 'System Cheque' || pvItem.payment_mode === 'Manual Cheque'">
                            <div class="d-flex field-display-basic">
                                <span class="label">Cheque Bank</span>
                                <span class="value">{{pvItem.cheque_bank || "--"}}</span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4" v-if="pvItem.payment_mode === 'System Cheque' || pvItem.payment_mode === 'Manual Cheque'">
                        <b-col md="6">
                            <div class="d-flex field-display-basic">
                                <span class="label">Cheque Date</span>
                                <span class="value">{{pvItem.cheque_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--")}}</span>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <div class="d-flex field-display-basic">
                                <span class="label">Cheque Number</span>
                                <span class="value">{{pvItem.cheque_number || "--"}}</span>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="3">
                    <b-row class="mb-4">
                        <b-col md="12">
                            <div class="d-flex field-display-basic">
                                <span class="label width-131">
                                    Billing Address
                                    <gofix-button
                                        label="Edit"
                                        v-if="pvItem.pay_to_type === 'Manual' && pvItem.status != 'Paid' && pvItem.status != 'Rejected' && pvItem.status !== 'Posted' "
                                        @click="openEditAddress" noBorder fontNormal small />
                                </span>
                                <span class="value" >{{pvItem.billing_address || "--"}}</span>
                                <!--<span class="value" v-if="pvItem.pay_to_type === 'Supplier'">{{pvItem.billing_address || "--"}}</span>
                                <span class="value" v-if="pvItem.pay_to_type === 'Manual'">{{pvItem.address ? pvItem.address.display_address : "--"}}</span>-->
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="12">
                            <gofix-text-field classLabel="width-131" label="Not For Finance Posting" oneline>{{pvItem.is_not_for_finance_posting ? "Yes" : "No"}}</gofix-text-field>
                         </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <div class="d-flex field-display-basic">
                        <span class="label remarks">Remarks</span>
                        <span class="value">{{pvItem.remark}}</span>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="boxShadow noOverflow bg-white mb-3 pl-0 pr-0 pt-4 pb-0">
            <div class="title mb-2 pl-4 pr-4">Line Items</div>
            <gofix-default-table
                    class="noFullHeight scrollAbsolute"
                    tableClass="mb-4"
                    :settings="lineItem.tableConfig"
                    :table-items="lineItem.tableItems"
                    @load-items="getTableData"
                    @delete-items="deleteItems"
                    ref="gofixTable">
                <template v-if="pvItem.platform !== 'LM'" slot="gofix_table:after-btn-create">
                    <li class="control-item" v-if="$checkRole($accessModule.payment_voucher, 'update')  && pvItem.status === 'Draft' && pvItem.pay_to_type ==='Supplier'">
                        <a class="control-item-link cursor-pointer" @click="modals.addApInvoice.open = true" title="Add AP Invoice" v-b-tooltip.hover><img src="img/add-ap-invoice.png" alt="Add AP Invoice"></a>
                    </li>
                    <li class="control-item" v-if="$checkRole($accessModule.payment_voucher, 'update') && pvItem.status === 'Draft' && !checkSupplierUser()">
                        <a class="control-item-link cursor-pointer" @click="modals.addMiscExpense.open = true" title="Add Misc Expense" v-b-tooltip.hover><img src="img/add-misc-expense.png" alt="Add Misc Expense"></a>
                    </li>
                    <li class="control-item" v-if="$checkRole($accessModule.payment_voucher, 'update') && pvItem.status === 'Draft' && pvItem.pay_to_type ==='Supplier' && !checkSupplierUser()">
                        <a class="control-item-link cursor-pointer" @click="modals.addLiquidatedDamages.open = true" title="Add Liquidated Damages" v-b-tooltip.hover>
                            <svg width="13" height="14" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1127 0.505273L14.526 4.91855C14.649 5.0416 14.7188 5.20977 14.7188 5.38408V12.5H13.2422V7.08008H8.8125C8.58406 7.08008 8.36498 6.98933 8.20345 6.8278C8.04192 6.66627 7.95117 6.44719 7.95117 6.21875V1.78906H1.75781V17.2109H7.5V18.6875H0.9375C0.574512 18.6875 0.28125 18.3942 0.28125 18.0312V0.96875C0.28125 0.605762 0.574512 0.3125 0.9375 0.3125H9.64922C9.82353 0.3125 9.98965 0.382227 10.1127 0.505273ZM9.3457 5.68555H13.2053L9.3457 1.82598V5.68555ZM7.99219 8.51562C8.08242 8.51562 8.15625 8.58945 8.15625 8.67969V10.8945H10.3711C10.4613 10.8945 10.5352 10.9684 10.5352 11.0586V12.043C10.5352 12.1332 10.4613 12.207 10.3711 12.207H8.15625V14.4219C8.15625 14.5121 8.08242 14.5859 7.99219 14.5859H7.00781C6.91758 14.5859 6.84375 14.5121 6.84375 14.4219V12.207H4.62891C4.53867 12.207 4.46484 12.1332 4.46484 12.043V11.0586C4.46484 10.9684 4.53867 10.8945 4.62891 10.8945H6.84375V8.67969C6.84375 8.58945 6.91758 8.51562 7.00781 8.51562H7.99219Z" fill="#999999"/>
                                <path opacity="0.5" d="M10.4697 18.1763H12.647V19H9.44434V14.0234H10.4697V18.1763ZM13.2383 19V14.0234H14.7695C15.207 14.0234 15.5978 14.1226 15.9419 14.3208C16.2882 14.5168 16.5583 14.797 16.752 15.1616C16.9456 15.5239 17.0425 15.9364 17.0425 16.3989V16.6279C17.0425 17.0905 16.9468 17.5018 16.7554 17.8618C16.5662 18.2218 16.2985 18.501 15.9521 18.6992C15.6058 18.8975 15.215 18.9977 14.7798 19H13.2383ZM14.2637 14.854V18.1763H14.7593C15.1603 18.1763 15.4668 18.0452 15.6787 17.7832C15.8906 17.5212 15.9989 17.1463 16.0034 16.6587V16.3955C16.0034 15.8896 15.8986 15.5068 15.689 15.2471C15.4793 14.985 15.1729 14.854 14.7695 14.854H14.2637Z" fill="black"/>
                            </svg>
                        </a>
                    </li>
                </template>
                <template slot="gofix_table:item_type" slot-scope="row">
                    {{row.item.item_type === 3  ? "Liquidated Damages" : row.item.item_type === 2  ? "Misc Expense" : row.item.item_type === 1 ? "AP Invoice" : "LM Created PV"}}
                </template>
                <template slot="gofix_table:item_date" slot-scope="row">
                    {{row.item.item_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                </template>
                <template slot="gofix_table:item_amount" slot-scope="row">
                    {{row.item.item_amount | formatMoney}}
                </template>
                <template slot="gofix_table:item_tax_amount" slot-scope="row">
                    {{row.item.item_tax_amount | formatMoney}}
                </template>
                <template slot="gofix_table:item_total" slot-scope="row">
                    {{row.item.item_total | formatMoney}}
                </template>
                <template slot="gofix_table:line_number" slot-scope="row">
                    {{row.index + 1}}
                </template>
                <template slot="gofix_table:item_number" slot-scope="row">
                    <span v-if="row.item.item_type !== 4" style="text-decoration: underline" @click="goToDetail(row.item)">{{row.item.item_number}}</span>
                </template>
                <template slot="gofix_table:bottom-row" slot-scope="row">
                    <template v-for="field in row.data.fields">
                        <td class="title font-14"
                            v-bind:class="(field.key === 'item_description' || field.key === 'item_total' || field.key === 'item_amount'|| field.key === 'item_tax_amount') ? field.tdClass : ''">
                            <span v-if="field.key === 'item_description'">Total</span>
                            <span v-if="field.key === 'item_total'">{{pvItem.total | formatMoney}}</span>
                            <span v-if="field.key === 'item_amount'">{{pvItem.amount | formatMoney}}</span>
                            <span v-if="field.key === 'item_tax_amount'">{{pvItem.gst | formatMoney}}</span>
                        </td>
                    </template>
                </template>
            </gofix-default-table>
        </div>

        <gofix-attachment :Item="pvItem" :attachable_type="'pvs'" title="Attachments" classCard="mb-0" classHeaderCard="pl-4" :isFixed="false"></gofix-attachment>

        <!--payment voucher date (pv_date)-->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="edit payment voucher" hide-footer :centered="true" v-model="modals.editDate.open">
            <b-form class="formInvoice pb-10">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input-date
                            v-model="modals.editDate.data.pv_date"
                            label="PV date" />
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveModalPvDate" :loading="modals.editDate.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <!--Payment voucher - Info-->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="edit payment voucher" hide-footer :centered="true" v-model="modals.editInfo.open">
            <b-form class="formV2">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Pay to type"
                            :options="modals.editInfo.payTypes"
                            :filterable="false"
                            :disabled="true"
                            v-model="pvItem.pay_to_type"
                            :clearable="false" />
                    </b-col>
                    <b-col md="12" v-if="pvItem.pay_to_type === 'Manual' && pvItem.address">
                        <gofix-form-input label="Pay to" v-model="pvItem.pay_to_name" disabled></gofix-form-input>
                    </b-col>
                    <b-col md="12" v-if="pvItem.pay_to_type === 'Supplier'">
                        <gofix-form-dropdown
                                label="Pay to"
                                vLabel="name"
                                :filterable="false"
                                :disabled="true"
                                :options="[]"
                                v-model="pvItem.get_pay_to">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12" v-if="pvItem.pay_to_type === 'Supplier'">
                        <div class="billingAddress mb-3">
                            <span class="title">billing address</span>
                            <div>{{pvItem.billing_address || "--"}}</div>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-dropdown
                            label="Payment Mode"
                            v-model="modals.editInfo.data.payment_mode"
                            :options="modals.editInfo.payModes" />
                    </b-col>
                    <b-col md="6" v-if="modals.editInfo.data.payment_mode === 'System Cheque' || modals.editInfo.data.payment_mode === 'Manual Cheque'">
                        <gofix-form-input label="Cheque Bank" v-model="modals.editInfo.data.cheque_bank"></gofix-form-input>
                    </b-col>
                    <b-col md="6" v-if="modals.editInfo.data.payment_mode === 'System Cheque' || modals.editInfo.data.payment_mode === 'Manual Cheque'">
                        <gofix-form-input label="Cheque Number" v-model="modals.editInfo.data.cheque_number"></gofix-form-input>
                    </b-col>
                    <b-col md="6" v-if="modals.editInfo.data.payment_mode === 'System Cheque' || modals.editInfo.data.payment_mode === 'Manual Cheque'">
                        <gofix-form-input-date
                            v-model="modals.editInfo.data.cheque_date"
                            label="Cheque Date" />
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Remarks" v-model="modals.editInfo.data.remark" />
                    </b-col>
                    <b-col md="12" v-if="isShowCheckBoxNavision">
                        <div class="d-flex">
                            <b-form-checkbox v-model="modals.editInfo.data.is_not_for_finance_posting" class="checkbox-pv-allow"><span class="ml-2">Not For Finance Posting</span></b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveModalPvInfo" :loading="modals.editInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <!-- Payment Add Ap Invoice -->
        <b-modal :no-close-on-backdrop="true" id="modal-select-invoice" title="Select AP Invoice" hide-footer :centered="true" v-model="modals.addApInvoice.open">
            <b-row class="content" v-bind:class="{'run-loading':modals.addApInvoice.loading}">
                <b-col md="12">
                    <div class="tableData">
                        <gofix-default-table class="noFullHeight"
                            :settings="apInvoice.tableConfig"
                            :table-items="apInvoice.tableItems"
                            @load-items="getTableDataApInvoice"
                            @get-selected="saveApInvoiceLineItem"
                            ref="gofixTableApInvoice">
                            <template slot="gofix_table:invoice_date" slot-scope="row">
                                {{row.item.invoice_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                {{row.item.amount | formatMoney}}
                            </template>
                            <template slot="gofix_table:gst" slot-scope="row">
                                {{row.item.gst | formatMoney}}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{row.item.total | formatMoney}}
                            </template>
                        </gofix-default-table>
                    </div>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="callSaveApInvoiceLineItem" noBorder></gofix-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-modal>

        <!-- Payment Add Misc Expense -->
        <b-modal :no-close-on-backdrop="true" id="modal-select-expense" modal-class="modal-select-pv-item" title="Select Misc Expense" hide-footer :centered="true" v-model="modals.addMiscExpense.open">
            <b-row class="content" v-bind:class="{'run-loading':modals.addMiscExpense.loading}">
                <b-col md="12">
                    <div class="tableData">
                        <gofix-table class="noFullHeight"
                            :settings="apExpense.tableConfig"
                            :table-items="apExpense.tableItems"
                            @load-items="getTableDataMiscExpense"
                            @get-selected="saveMiscExpenseLineItem"
                            ref="gofixTableMiscExpense">
                            <template slot="gofix_table:claim_date" slot-scope="row">
                                {{row.item.claim_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                {{row.item.amount | formatMoney}}
                            </template>
                            <template slot="gofix_table:tax_amount" slot-scope="row">
                                {{row.item.tax_amount | formatMoney}}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{(row.item.amount + row.item.tax_amount) | formatMoney}}
                            </template>
                        </gofix-table>
                    </div>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="callsaveMiscExpenseLineItem" noBorder></gofix-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-modal>

        <!-- Payment Add Liquidated Damages -->
        <b-modal :no-close-on-backdrop="true" id="modal-select-liquidated" modal-class="modal-select-pv-item" title="Select liquidated damages" hide-footer :centered="true" v-model="modals.addLiquidatedDamages.open">
            <b-row class="content" v-bind:class="{'run-loading':modals.addLiquidatedDamages.loading}">
                <b-col md="12">
                    <div class="tableData">
                        <gofix-table class="noFullHeight"
                            :settings="liquidatedDamages.tableConfig"
                            :table-items="liquidatedDamages.tableItems"
                            @load-items="getTableDataLiquidatedDamages"
                            @get-selected="saveLiquidatedDamagesLineItem"
                            ref="gofixTableLiquidatedDamages">
                            <template slot="gofix_table:ld_date" slot-scope="row">
                                {{row.item.ld_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                {{row.item.amount | formatMoney}}
                            </template>
                            <template slot="gofix_table:tax_amount" slot-scope="row">
                                {{row.item.tax_amount | formatMoney}}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{row.item.total | formatMoney}}
                            </template>
                        </gofix-table>
                    </div>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="callsaveLiquidatedDamagesLineItem" noBorder></gofix-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-modal>

        <!-- Address -->
        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" v-model="modals.address.open">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="modals.address.data.street_no"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="modals.address.data.street_name"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="modals.address.data.unit_no"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="modals.address.data.building_name"></gofix-form-input>
                <gofix-form-input label="Country" v-model="modals.address.data.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal code" v-model="modals.address.data.postal_code"></gofix-form-input>
            </b-form>

            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveAddress" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <!-- chosen approval  -->
        <b-modal :no-close-on-backdrop="true" id="modal-reading" title="Approval Template" hide-footer :centered="true" v-model="modals.approval.open">
            <div v-bind:class="{'run-loading':modals.approval.loading}">
                <gofix-form-dropdown
                    label="Approval"
                    vLabel="title"
                    :options="modals.approval.options_approval"
                    v-model="modals.approval.approval_template_id" />
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="saveApprovalTemplate" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import attachment from '@/views/attachments/list';
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';
    export default {
        name: 'payment-voucher-info',
        components: {
            attachment
        },
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['payment_voucher_item']));
            return {
                modals:{
                    editDate: {
                        open: false,
                        loading: false,
                        data: {
                            pv_date: null,
                        }
                    },
                    editInfo:{
                        open: false,
                        loading: false,
                        data: {
                            payment_mode: null,
                            cheque_bank: null,
                            cheque_date: null,
                            cheque_number: null,
                            client_contract_id:null,
                            remark: null,
                            is_not_for_finance_posting: false,
                        },
                        payTypes:["Supplier","Manual"],
                        payModes:['Electronic Transfer', 'System Cheque', 'Manual Cheque'],
                        contract:{
                            data: [],
                            timer:null
                        }
                    },
                    addApInvoice:{
                        open: false,
                        loading: false,
                        data:{}
                    },
                    addMiscExpense:{
                        open: false,
                        loading: false,
                    },
                    addLiquidatedDamages:{
                        open: false,
                        loading: false,
                    },
                    address: {
                        open: false,
                        loading: false,
                        data:{
                            id: null,
                            first_name:     '',
                            last_name:      '',
                            display_name:    '',
                            street_no:      '',
                            street_name:    '',
                            building_name:  '',
                            unit_no: '',
                            city: '',
                            country: 'Singapore',
                            postal_code: ''
                        }
                    },
                    approval: {
                        open: false,
                        loading: false,
                        options_approval: [],
                        approval_template_id: null,
                    }
                },
                lineItem:{
                    tableConfig:{
                        name: 'payment-voucher-line-items',
                        controls:{
                            create: false,
                            delete: false
                        },
                        filter: filter,
                        page: 1,
                        limit: 100,
                        total: 0,
                        useDatabaseView: true,
                        sortColumn: "line_number",
                        sortDirection: "asc",
                    },
                    tableItems: [],
                },
                apInvoice:{
                    tableConfig:{
                        name: 'payment-voucher-line-item-source-ap-invoices',
                        controls:{
                            reload: false,
                            create: false,
                            delete: false,
                            tableFilter:false,
                            tableImport:false,
                            tableExport:false,
                            tableColumnSettings:false,
                            tablePagination:false,
                        },
                        filter: {},
                        page: 1,
                        limit: -1,
                        total: 0,
                        useDatabaseView: true,
                        sortColumn: null,
                        sortDirection: "asc",
                    },
                    tableItems: [],
                },
                apExpense:{
                    tableConfig:{
                        name: 'payment-line-item-source',
                        controls:{
                            reload: false,
                            create: false,
                            delete: false,
                            tableFilter:false,
                            tableImport:false,
                            tableExport:false,
                            tableColumnSettings:false,
                            tablePagination:false,
                        },
                        filter: {},
                        page: 1,
                        limit: -1,
                        total: 0,
                        useDatabaseView: true,
                        sortColumn: null,
                        sortDirection: "asc",
                        fields: [
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-center',
                                tdClass: 'checkbox-column text-center',
                                width: 50,
                                thStyle: "width:50px",
                            },
                            {
                                key: 'claim_number',
                                label: 'Expense Claim No',
                                isActive: 1,
                                isFilter: false,
                                with:170,
                                thStyle: "width:170px",
                                sorting: true,
                            },
                            {
                                key: 'receipt_no',
                                label: 'Receipt No',
                                isActive: 1,
                                isFilter: false,
                                with:150,
                                thStyle: "width:150px",
                                sorting: true,
                            },
                            {
                                key: 'claim_date',
                                label: 'Expanse Claim date',
                                isActive: 1,
                                isFilter: false,
                                with:150,
                                thStyle: "width:150px",
                                sorting: true,
                            },
                            {
                                key: 'claim_description',
                                label: 'Description',
                                isActive: 1,
                                isFilter: false,
                                with:null,
                                thStyle: "width:auto",
                                sorting: true,
                            },
                            {
                                key: 'amount',
                                label: 'Amount',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1,
                                isFilter: false,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            },
                            {
                                key: 'tax_amount',
                                label: 'Tax Amount',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1,
                                isFilter: false,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1,
                                isFilter: false,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            }
                        ]
                    },
                    tableItems: [],
                },
                liquidatedDamages:{
                    tableConfig:{
                        name: 'payment-line-item-source',
                        controls:{
                            reload: false,
                            create: false,
                            delete: false,
                            tableFilter:false,
                            tableImport:false,
                            tableExport:false,
                            tableColumnSettings:false,
                            tablePagination:false,
                        },
                        filter: {},
                        page: 1,
                        limit: -1,
                        total: 0,
                        useDatabaseView: true,
                        sortColumn: null,
                        sortDirection: "asc",
                        fields: [
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-center',
                                tdClass: 'checkbox-column text-center',
                                width: 50,
                                thStyle: "width:50px",
                            },
                            {
                                key: 'ld_number',
                                label: 'LD No',
                                isActive: 1,
                                isFilter: false,
                                with:170,
                                thStyle: "width:170px",
                                sorting: true,
                            },
                            {
                                key: 'ld_date',
                                label: 'LD/Credit Note date',
                                isActive: 1,
                                isFilter: false,
                                with:180,
                                thStyle: "width:180px",
                                sorting: true,
                            },
                            {
                                key: 'amount',
                                label: 'Amount',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1,
                                isFilter: false,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            },
                            {
                                key: 'tax_amount',
                                label: 'Tax Amount',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1,
                                isFilter: false,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1,
                                isFilter: false,
                                with:120,
                                thStyle: "width:120px",
                                sorting: true,
                            }
                        ]
                    },
                    tableItems: [],
                },
                isShowCheckBoxNavision:true
            }
        },
        watch: {
            "currentRoles": function(val,old){
                if(this.pvItem && this.pvItem.id) {
                    this.lineItem.tableConfig.controls.create = false;
                    this.updateDeleted(this.pvItem.status);
                }
            },
            pvItem: function(val, old) {
                if(val && val.id) {
                    this.updateDeleted(val.status);
                }
            }
        },
        computed: {
            ...mapGetters({
                pvItem: "PaymentVoucherController/Item",
                currentRoles: 'AuthController/roles',
                UserLogin: "AuthController/user"
            }),
            getCreditorCode() {
                var creditor_code = '';
                var source_description = '';
                if(this.pvItem.creditor_code) creditor_code = this.pvItem.creditor_code;
                if(this.pvItem.get_pay_to && this.pvItem.get_pay_to.vendor_linking_creditor_code) {
                    if(this.pvItem.contract && this.pvItem.contract.finance_company && this.pvItem.contract.finance_company.company && this.pvItem.contract.finance_company.company.id) {
                        const arrTmp = this.pvItem.get_pay_to.vendor_linking_creditor_code.filter(item => item.coa_companie_id == this.pvItem.contract.finance_company.company.id && (creditor_code && item.creditor_code && item.creditor_code.source_code && creditor_code == item.creditor_code.source_code));
                        if(arrTmp.length) {
                            source_description = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_description ? (" - " + arrTmp[0].creditor_code.source_description) : '';
                        }
                    }
                }
                
                if(creditor_code) return creditor_code + source_description;
                return;
            }
        },
        created() {
            if(this.pvItem && this.pvItem.id) this.updateDeleted(this.pvItem.status);
        },
        methods: {
            /* ----Save data ----------------------------------------------------*/
            saveData(data){
                let params = Object.assign({id: this.$route.params.payment_id},data);
                this.$store.dispatch(`PaymentVoucherController/updatePayment`, params)
                    .then(response => {
                        return this.$alertNotification(this.$notificationV2('editing', 'payment_voucher'));
                    })
                    .catch(err => {
                        console.log(err);
                        return this.$alertNotification("Update failed", "danger");
                    })
            },
            async saveModalPvDate(){
                if(this.modals.editDate.loading) return;
                if(!this.modals.editDate.data.pv_date){
                    return this.$alertNotification("Please select a date", "danger");
                }
                let data = {
                    pv_date : moment(new Date(this.modals.editDate.data.pv_date)).format('YYYY-MM-DD')
                };
                this.modals.editDate.loading = true;
                await this.saveData(data);
                this.modals.editDate.loading = false;
                this.modals.editDate.open = false;
            },
            async saveModalPvInfo(){
                if(this.modals.editInfo.loading) return;
                if(!this.modals.editInfo.data.client_contract_id){
                    return this.$alertNotification('"Client Contract" is required field', "danger");
                }

                let data = {
                    cheque_date : moment(new Date(this.modals.editInfo.data.cheque_date)).format('YYYY-MM-DD'),
                    payment_mode: this.modals.editInfo.data.payment_mode,
                    cheque_bank: this.modals.editInfo.data.cheque_bank,
                    cheque_number: this.modals.editInfo.data.cheque_number,
                    remark: this.modals.editInfo.data.remark,
                    is_not_for_finance_posting: this.modals.editInfo.data.is_not_for_finance_posting,
                };
                this.modals.editInfo.loading = true;
                await this.saveData(data);
                this.modals.editInfo.loading = false;
                this.modals.editInfo.open = false;
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('PaymentVoucherController/deleteLineItems', ids)
                    .then(response => {
                        this.getPV();
                        resolve(this.$notificationV2('deleting', 'line_item'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            callSaveApInvoiceLineItem(){
                this.$refs.gofixTableApInvoice.sendSelectedData();
            },
            saveApInvoiceLineItem(ids){
                //createLineItems
                let params = {
                    item_ids : ids,
                    item_type: 1,
                    payment_voucher_id: this.pvItem.id
                };
                if(this.modals.addApInvoice.loading) return;
                this.modals.addApInvoice.loading = true;
                this.$store.dispatch("PaymentVoucherController/createLineItems", params)
                    .then(response => {
                        this.modals.addApInvoice.loading = false;
                        this.modals.addApInvoice.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.getPV();
                        this.$alertNotification(this.$notificationV2('adding', 'line_item'));
                    })
                    .catch(err => {
                        console.log(err);
                        this.modals.addApInvoice.loading = false;
                        this.$alertNotification("Can add PV item", "danger");
                    })
            },
            callsaveMiscExpenseLineItem(){
                this.$refs.gofixTableMiscExpense.sendSelectedData();
            },
            saveMiscExpenseLineItem(ids){
                //createLineItems
                let params = {
                    item_ids : ids,
                    item_type: 2,
                    payment_voucher_id: this.pvItem.id
                };
                if(this.modals.addMiscExpense.loading) return;
                this.modals.addMiscExpense.loading = true;
                this.$store.dispatch("PaymentVoucherController/createLineItems", params)
                    .then(response => {
                        this.modals.addMiscExpense.loading = false;
                        this.modals.addMiscExpense.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.getPV();
                        this.$alertNotification(this.$notificationV2('adding', 'line_item'));
                    })
                    .catch(err => {
                        console.log(err);
                        this.modals.addMiscExpense.loading = false;
                        this.$alertNotification("Can add PV item", "danger");
                    })
            },
            saveLiquidatedDamagesLineItem(ids){
                //createLineItems
                let params = {
                    item_ids : ids,
                    item_type: 3,
                    payment_voucher_id: this.pvItem.id
                };
                if(this.modals.addLiquidatedDamages.loading) return;
                this.modals.addLiquidatedDamages.loading = true;
                this.$store.dispatch("PaymentVoucherController/createLineItems", params)
                    .then(response => {
                        this.modals.addLiquidatedDamages.loading = false;
                        this.modals.addLiquidatedDamages.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.getPV();
                        this.$alertNotification(this.$notificationV2('adding', 'line_item'));
                    })
                    .catch(err => {
                        console.log(err);
                        this.modals.addLiquidatedDamages.loading = false;
                        this.$alertNotification("Can add PV item", "danger");
                    })
            },
            callsaveLiquidatedDamagesLineItem(){
                this.$refs.gofixTableLiquidatedDamages.sendSelectedData();
            },
            async saveAddress(){
                if(this.modals.address.loading) return;
                let data = {
                    address : this.modals.address.data
                };
                this.modals.address.loading = true;
                await this.saveData(data);
                //AddressController
                this.modals.address.loading = false;
                this.modals.address.open = false;
            },
            /* ---- Get data ----------------------------------------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.payment_voucher_id.value = this.$route.params.payment_id;
                await this.$store.dispatch("PaymentVoucherController/getLineItems", tableRequest)
                    .then(response => {
                        this.lineItem.tableItems = response.items;
                        this.lineItem.tableConfig.total = response.total;
                        this.$emit('checkLineItemIsNull',response.items.length == 0 ?  true : false );
                        resolve(response);

                        this.checkApprovalTemplate();
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async getTableDataApInvoice(callback){
                const { tableRequest , resolve,reject } = await callback();
                delete tableRequest.isCMS;
                tableRequest.filter = {
                    supplier_id: this.pvItem.pay_to_id,
                    used_invoice_id: true,
                    client_contract_id: this.pvItem.client_contract_id,
                    status: "Verified",
                };
                await this.$store.dispatch("PaymentVoucherController/getInvoices", tableRequest)
                    .then(response => {
                        this.apInvoice.tableItems = response.data.data.items;
                        this.apInvoice.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        reject(err);
                    })
            },
            async getTableDataMiscExpense(callback){
                const { tableRequest , resolve,reject } = await callback();
                delete tableRequest.isCMS;
                if(this.pvItem.pay_to_type === "Supplier"){
                    tableRequest.filter = {
                        payee_id: this.pvItem.pay_to_id,
                        client_contract_id: this.pvItem.client_contract_id,
                        status: "Submitted",
                        payee_type: "Supplier",
                    };
                }else{
                    tableRequest.filter = {
                        payee_id: this.pvItem.manual_pay_to_id,
                        client_contract_id: this.pvItem.client_contract_id,
                        status: "Submitted",
                        payee_type: "Manual",
                    };
                }
                await this.$store.dispatch("MiscExpensesController/getItems", tableRequest)
                    .then(response => {
                        this.apExpense.tableItems = response.items;
                        this.apExpense.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.apExpense.tableItems = [];
                        this.apExpense.tableConfig.total = 0;
                        reject();
                    });
            },
            async getTableDataLiquidatedDamages(callback){
                const { tableRequest , resolve,reject } = await callback();
                delete tableRequest.isCMS;
                tableRequest.filter = {
                    "liquidated_damages.supplier_id": this.pvItem.pay_to_id,
                    client_contract_id: this.pvItem.client_contract_id,
                    "liquidated_damages.status": "Submitted",
                };
                await this.$store.dispatch("LiquidatedDamagesController/getItems", tableRequest)
                    .then(response => {
                        this.liquidatedDamages.tableItems = response.items;
                        this.liquidatedDamages.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.liquidatedDamages.tableItems = [];
                        this.liquidatedDamages.tableConfig.total = 0;
                        reject();
                    });
            },
            getPV(){
                this.$store.dispatch('PaymentVoucherController/getPayment', this.$route.params.payment_id).then(response => {
                    this.checkApprovalTemplate();
                });
            },
            /* ---- Attributes ----------------------------------------------------*/
            openEditPVdate(){
                this.modals.editDate.data.pv_date = this.pvItem.pv_date ? new Date(moment(this.pvItem.pv_date, "YYYY-MM-DD").toISOString()) : null;
                this.modals.editDate.open = true;
            },
            openEditPVInfo(){
                this.modals.editInfo.data.payment_mode = this.pvItem.payment_mode;
                this.modals.editInfo.data.cheque_bank = this.pvItem.cheque_bank;
                this.modals.editInfo.data.cheque_number = this.pvItem.cheque_number;
                this.modals.editInfo.data.cheque_date = this.pvItem.cheque_date ? new Date(moment(this.pvItem.cheque_date, "YYYY-MM-DD").toISOString()) : null;
                this.modals.editInfo.data.remark = this.pvItem.remark;
                this.modals.editInfo.data.client_contract_id = this.pvItem.client_contract_id;
                this.modals.editInfo.data.is_not_for_finance_posting = this.pvItem.is_not_for_finance_posting;
                this.modals.editInfo.open = true;
                if(this.pvItem.contract && this.pvItem.contract.settings && this.pvItem.contract.settings.exclude_journal_entries_navision){
                    this.isShowCheckBoxNavision = false;
                    return;
                }
                this.isShowCheckBoxNavision = true;
            },
            goToDetail(item){
                if(item.item_type === 2){
                    this.$router.push(`/v2/misc-expenses/${item.item_id}`);
                }else if(item.item_type === 1){
                    this.$router.push(`/v2/ap-invoice/${item.item_id}`)
                }else{
                    this.$router.push(`/v2/liquidated-damages/${item.item_id}`)
                }
            },
            openEditAddress(){
                this.modals.address.data = {
                    id: this.pvItem.address_id,
                    first_name:     this.pvItem.address ? this.pvItem.address.first_name : null,
                    last_name:      this.pvItem.address ? this.pvItem.address.last_name : null,
                    display_name :  this.pvItem.address ? this.pvItem.address.display_name : null,
                    street_no:      this.pvItem.address ? this.pvItem.address.street_no : null,
                    street_name:    this.pvItem.address ? this.pvItem.address.street_name : null,
                    building_name:  this.pvItem.address ? this.pvItem.address.building_name : null,
                    unit_no: this.pvItem.address ? this.pvItem.address.unit_no : null,
                    city: this.pvItem.address ? this.pvItem.address.city : null,
                    country: this.pvItem.address ? this.pvItem.address.country : 'Singapore',
                    postal_code: this.pvItem.address ? this.pvItem.address.postal_code : null,
                };
                this.modals.address.open = true;
            },
            async updateDeleted(val){
                if(val != 'Draft') {
                    this.lineItem.tableConfig.controls.delete = false
                } else {
                    this.lineItem.tableConfig.controls.delete = this.$checkRole(this.$accessModule.payment_voucher, 'update');
                }

                this.$nextTick(() => {
                    this.$refs['gofixTable'].updateDeletedBT()
                });
            },
            checkSupplierUser(){
                if(this.UserLogin.organization && this.UserLogin.organization.is_supplier)
                    return true;
                return false;
            },
            showApprovalTitle(approval_template) {
                if ( approval_template ) {
                    let title = (approval_template.approval_process ? approval_template.approval_process.reference_value_text : '') + ' - ' + (approval_template.location ? approval_template.location.name : '')
                    if(approval_template.effective_date) title += ` (${moment(approval_template.effective_date).format("DD.MM.YYYY")})`;
                    return title;
                }

                return '---';
            },
            async checkApprovalTemplate() {
                
                if ( this.pvItem.approval_template_id || this.lineItem.tableItems.length == 0 ) {
                    return;
                }
                
                let requestData = {
                    limit: -1,
                    page: 1,
                    filter: {
                        name_null : true,
                        contract_id : this.pvItem.client_contract_id
                    }
                };

                await this.$store.dispatch('ApprovalTemplateController/getItems', requestData)
                .then(response => {

                    this.modals.approval.options_approval = [];

                    if ( response.items ) {
                        response.items.forEach((item) => { 
                            
                            if(!item.is_current && item.effective_date && moment().isSameOrAfter(moment(item.effective_date))) {
                                return;
                            }
                            
                            if ( item.approval_process && item.approval_process.reference_value_text != 'FM PV Approval') {
                                return;
                            }
                            
                            if ( moment(item.effective_date) > moment() ) {
                                return;
                            }

                            this.modals.approval.options_approval.push({
                                id: item.id,
                                title: this.showApprovalTitle(item)
                            })
                        });
                        
                        if ( this.pvItem.approval_template_id || this.lineItem.tableItems.length == 0 ) {
                            //
                        } else {
                            this.modals.approval.open = true
                        }
                    }
                })
                .catch(err => { });
            },
            async saveApprovalTemplate() {

                if(!this.modals.approval.approval_template_id){
                    return this.$alertNotification('Please select a Approval Template', 'danger');
                }

                this.modals.approval.loading = true;
                
                let data = {
                    approval_template_id: this.modals.approval.approval_template_id.id
                };

                await this.saveData(data);
                this.modals.options_approval = [];
                this.modals.approval.loading = false;
                this.modals.approval.approval_template_id = null;
                this.modals.approval.open = false;
            },
            async editApprovalTemplate() {
                if ( this.pvItem.status != 'Draft' || this.pvItem.approval_template_id == null ) {
                    return this.$alertNotification("Can't edit Approval Template", 'danger');
                }

                let requestData = {
                    limit: -1,
                    page: 1,
                    filter: {
                        name_null : true,
                        contract_id : this.pvItem.client_contract_id
                    }
                };

                await this.$store.dispatch('ApprovalTemplateController/getItems', requestData)
                .then(response => {

                    this.modals.approval.options_approval = [];

                    if ( response.items ) {
                        response.items.forEach((item) => { 
                            
                            if(!item.is_current && item.effective_date && moment().isSameOrAfter(moment(item.effective_date))) {
                                return;
                            }
                            
                            if ( item.approval_process && item.approval_process.reference_value_text != 'FM PV Approval') {
                                return;
                            }
                            
                            if ( moment(item.effective_date) > moment() ) {
                                return;
                            }

                            this.modals.approval.options_approval.push({
                                id: item.id,
                                title: this.showApprovalTitle(item)
                            })
                        });
                        
                        this.modals.approval.open = true
                    }
                })
                .catch(err => { });
            }
        }
    }
</script>
